export default __webpack_public_path__ + "static/media/speed_retreat.fe074a37.svg";